import { render, staticRenderFns } from "./listaTratamientos.vue?vue&type=template&id=a5b949b2&scoped=true"
import script from "./listaTratamientos.vue?vue&type=script&lang=js"
export * from "./listaTratamientos.vue?vue&type=script&lang=js"
import style0 from "./listaTratamientos.vue?vue&type=style&index=0&id=a5b949b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5b949b2",
  null
  
)

export default component.exports